const init = { leaves:[], loading:false, error:null };
export const leaveReducer = (state=init, action) => {
  switch(action.type) {
    case "LEAVES_REQUEST": return { ...state, loading:true };
    case "LEAVES_SUCCESS": return { ...state, loading:false, leaves: action.payload };
    case "LEAVES_FAIL":    return { ...state, loading:false, error: action.payload };
    default: return state;
  }
};
